import React from "react";
import FellowshipsSection from "../components/Achievements/FellowshipsSection";
import MediaFeaturesSection from "../components/Achievements/MediaFeaturesSection";
import CertificationsSection from "../components/Achievements/CertificationsSection";
import SEO from "../components/common/SEO";

const AchievementsPage = () => {
  const achievementsStructuredData = {
    "@context": "https://schema.org",
    "@type": "ProfilePage",
    "name": "Professional Achievements & Certifications - Mihir Shah",
    "description": "Professional achievements, certifications, fellowships, and media features of Mihir Shah's cybersecurity expertise and OWASP leadership.",
    "url": "https://mihirshah.tech/achievements",
    "mainEntity": {
      "@type": "Person",
      "name": "Mihir Shah",
      "hasCredential": [
        {
          "@type": "EducationalOccupationalCredential",
          "name": "OSCP - Offensive Security Certified Professional",
          "credentialCategory": "Cybersecurity Certification"
        },
        {
          "@type": "EducationalOccupationalCredential",
          "name": "CKA - Certified Kubernetes Administrator",
          "credentialCategory": "Cloud Technology Certification"
        },
        {
          "@type": "EducationalOccupationalCredential",
          "name": "CKS - Certified Kubernetes Security Specialist",
          "credentialCategory": "Cloud Security Certification"
        }
      ],
      "award": [
        {
          "@type": "Award",
          "name": "OWASP VXDF Project Leader",
          "description": "Leadership of the OWASP Validated Exploitable Data Flow project"
        },
        {
          "@type": "Award", 
          "name": "Published Author",
          "description": "Cloud Native Software Security Handbook by Packt Publishing"
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Professional Achievements & Certifications - Mihir Shah"
        description="Explore Mihir Shah's professional achievements including cybersecurity certifications (OSCP, CKA, CKS), OWASP project leadership, fellowships, published work, and media features in the security industry."
        keywords="Mihir Shah achievements, cybersecurity certifications, OSCP, CKA, CKS, OWASP project leader, security fellowships, published author, media features, professional recognition"
        url="https://mihirshah.tech/achievements"
        type="website"
        section="Achievements"
        tags={["Achievements", "Certifications", "Awards", "Professional Recognition"]}
        structuredData={achievementsStructuredData}
      />
      <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-vxdf-primary to-vxdf-accent bg-clip-text text-transparent">
              Professional Achievements
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Certifications, fellowships, recognitions, and milestones in cybersecurity excellence and OWASP project leadership
            </p>
          </div>
          
          <CertificationsSection />
          <FellowshipsSection />
          <MediaFeaturesSection />
        </div>
      </div>
    </>
  );
};

export default AchievementsPage;
